export class DateUtils {
    public static getFiscalQuarterStartDate(date: Date): Date {
        const dueDate = new Date(date);
        const quarter = Math.floor(dueDate.getMonth() / 3);
        const quarterStartDate = new Date(dueDate.getFullYear(), quarter * 3, 1);

        return quarterStartDate;
    }

    public static getFiscalQuarterEndDate(date: Date): Date {
        const quarter = Math.floor(date.getMonth() / 3);
        const quarterEndDate = new Date(date.getFullYear(), (quarter + 1) * 3, 0);
        return quarterEndDate;
    }

    public static getUtcDate(date: Date): Date {
        const dateString = date.toString();

        // API is returning a non-UTC date string, so this is a workaround to convert it to UTC
        const utcDateString = dateString.endsWith('Z')
            ? dateString
            : `${dateString}Z`;

        return new Date(utcDateString);
    }
}


// WEBPACK FOOTER //
// ./src/app/core/utilities/dateUtils.ts